import script from "./dialogHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./dialogHeader.vue?vue&type=script&setup=true&lang=js"

import "./dialogHeader.vue?vue&type=style&index=0&id=725b7dd4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1751107138/src/flip-child-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-725b7dd4"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QDialog,QCardSection});
